import React from "react";
import { Field } from "formik";
interface FormikFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  placeholder?: string;
}
const FormikField = ({
  name,
  label,
  placeholder,
  ...props
}: FormikFieldProps) => {
  return (
    <div className="mb-4">
      {label && (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium opacity-50 font-montserrat"
        >
          {label}
        </label>
      )}
      <Field
        id={name}
        name={name}
        placeholder={placeholder}
        className="w-full px-4 py-3 bg-transparent placeholder:text-white placeholder:opacity-50 border-b shadow-sm font-montserrat focus:ring-0 active:ring-0 focus:outline-none focus:ring-blue-500"
        {...props}
      />
    </div>
  );
};
export default FormikField;
